import { useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import { trackRecordingFeedbackLeft } from '@hotjar/webapp/features/Playbacks/utils/tracking';
import * as Track from '@hotjar/webapp/tracking/tools/hotjar';
import { Store } from '../../../store/player/types';

/**
 * Update if a recording is worth watching.
 */
export const updateWorthWatchingAnswer = (store: Store, worthWatching: boolean | null): void => {
  const { isWorthWatching, done, recording, setWorthWatching } = store.getState();

  let feedback_given;
  if (worthWatching === true) {
    feedback_given = 'upvoted';
  } else if (worthWatching === false) {
    feedback_given = 'downvoted';
  } else if (isWorthWatching === true) {
    // It was true and it's now null
    feedback_given = 'removed_upvote';
  } else {
    // It was false and it's now null
    feedback_given = 'removed_downvote';
  }

  const currentTime = useRealTimeStore.getState().currentTime;

  if (recording) {
    trackRecordingFeedbackLeft(recording, {
      recording_id: recording.id,
      ui_position: done ? 'recording_end_screen' : 'recording_header',
      point_in_timeline_seconds: Math.round(currentTime / 1000),
      point_in_timeline_playback_percentage: Math.round((currentTime / recording.duration) * 100),
      feedback_given,
    });
  }

  // The backend call has already been done in react, we just need to update the model in angular
  setWorthWatching(!!worthWatching);
  if (worthWatching) {
    Track.tagRecording('rated_recording_worth_watching');
    Track.trigger('rated_recording_thumbs_up');
  } else if (!worthWatching) {
    Track.tagRecording('rated_recording_not_worth_watching');
    Track.trigger('rated_recording_thumbs_down');
  }
};
